/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const WebAppStationDtoAccessTypeEnum = {
    OWNED: "OWNED",
    SHARED: "SHARED"
} as const;

export type WebAppStationDtoAccessTypeEnumKey = (typeof WebAppStationDtoAccessTypeEnum)[keyof typeof WebAppStationDtoAccessTypeEnum];

export const WebAppStationDtoTypeEnum = {
    STANDALONE: "STANDALONE",
    HEADER: "HEADER",
    REPEATER: "REPEATER",
    AFFILIATE: "AFFILIATE"
} as const;

export type WebAppStationDtoTypeEnumKey = (typeof WebAppStationDtoTypeEnum)[keyof typeof WebAppStationDtoTypeEnum];

export type WebAppStationDto = {
    /**
     * @description Station unique identifier
     * @type string, uuid
    */
    id: string;
    /**
     * @description Station display name
     * @type string
    */
    name: string;
    /**
     * @description URL-safe unique slug
     * @type string
    */
    slug: string;
    /**
     * @description Access relation for the requesting client: OWNED, SHARED, or null when not scoped
     * @type string
    */
    accessType?: WebAppStationDtoAccessTypeEnumKey | null;
    /**
     * @description Media format (e.g. audio, video)
     * @type string
    */
    format: string;
    /**
     * @description BCP-47 language code
     * @type string
    */
    language: string;
    /**
     * @description IANA or offset timezone string
     * @type string
    */
    timezone: string;
    /**
     * @description Alternate lookup names for the station
     * @type array | undefined
    */
    aliases?: string[];
    /**
     * @description Media retention window in days
     * @type integer
    */
    retentionDays?: number | null;
    /**
     * @description Absolute retention cutoff (ISO 8601)
     * @type string
    */
    retentionDate?: string | null;
    /**
     * @description Station topology type
     * @type string
    */
    type: WebAppStationDtoTypeEnumKey;
    /**
     * @description Public logo URL
     * @type string
    */
    logoUrl?: string | null;
    /**
     * @description Linked YouTube channel id
     * @type string
    */
    youtubeChannelId?: string | null;
    /**
     * @description Whether YouTube native ingest is enabled
     * @type boolean
    */
    youtubeNative: boolean;
    /**
     * @description DEPRECATED. Logger-api client FeatureProvider snapshot. Migrate to per-domain settings.
     * @type object
    */
    featuresConfig: {
        /**
         * @type object | undefined
        */
        audit?: {
            /**
             * @type boolean | undefined
            */
            enabled?: boolean;
            /**
             * @type boolean | undefined
            */
            liveMentionsEnabled?: boolean;
        };
        /**
         * @type object | undefined
        */
        export?: {
            /**
             * @type boolean | undefined
            */
            enabled?: boolean;
        };
        /**
         * @type object | undefined
        */
        fragments?: {
            /**
             * @type object | undefined
            */
            youtubeUpload?: {
                /**
                 * @type boolean
                */
                enabled?: boolean | null;
            };
            descriptionFooters?: any;
            platformUpload?: any;
            mediaWatermark?: any;
            audiogram?: any;
            tagGroups?: any;
            captions?: any;
            cfrTranscoding?: any;
        };
        /**
         * @type object | undefined
        */
        streamerBox?: {
            deviceId?: any;
        };
        /**
         * @type object | undefined
        */
        transcription?: {
            enabled?: any;
            diarization?: any;
            priority?: any;
        };
        /**
         * @type object | undefined
        */
        videoAnalysis?: {
            /**
             * @type boolean | undefined
            */
            enabled?: boolean;
            /**
             * @type object | undefined
            */
            lowerThird?: {
                /**
                 * @type boolean
                */
                enabled: boolean;
            };
            /**
             * @type object | undefined
            */
            adOverlays?: {
                /**
                 * @type boolean
                */
                enabled: boolean;
            };
            /**
             * @type object | undefined
            */
            screenBug?: {
                /**
                 * @type boolean
                */
                enabled: boolean;
            };
        };
        /**
         * @type object | undefined
        */
        programming?: object;
        /**
         * @type object | undefined
        */
        segmenter?: object;
    };
    /**
     * @description Station streams
     * @type array | undefined
    */
    streams?: {
        /**
         * @type boolean
        */
        main: boolean;
        /**
         * @type string, uri
        */
        url: string;
    }[];
};